import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import CommentReply from './CommentReply';
import AnnotationUtil from '../../queries/annotations/AnnotationUtil';
import { Annotation, AnnotationThread } from '../../autogenerated/ZoomBridge';
import StoreListener from '../../store/StoreListener';
import { EXPANDED_THREAD_IDS } from '../../store/Constants';
import Store from '../../store/Store';
import t from '../../i18n/I18n';
import { ThemeSetup } from '../../themes/ThemeSetup';

import './CommentReplies.css';

const debug = require('../../debug/debug')('wc:comments:CommentReplies');

const storeItems = [EXPANDED_THREAD_IDS];

@StoreListener(storeItems)
export default class CommentReplies extends React.Component {
  static propTypes = {
    comment: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onCloseRepliesClick: PropTypes.func,
    onEditStart: PropTypes.func,
    getCommentString: PropTypes.func,
    EXPANDED_THREAD_IDS: PropTypes.array
  };

  state = {
    showButtons: false,
    totalCommentCount: this.props.comment.getAnnotation().getReplies().length
  };

  showAllReplies = () => {
    const { comment, EXPANDED_THREAD_IDS } = this.props;
    return AnnotationUtil.getReplies(comment).length <= 3 || _.includes(EXPANDED_THREAD_IDS, comment.getThreadId());
  };

  onIndicatorLineClick = () => {
    Store.put(EXPANDED_THREAD_IDS, this.props[EXPANDED_THREAD_IDS].concat(this.props.comment.getThreadId()));
  };

  onEdit = (reply: Annotation) => {
    const updatedComment: AnnotationThread = _.cloneDeep(this.props.comment);
    const replies = updatedComment.getAnnotation().getReplies();
    const index = _.findIndex(replies, (r: Annotation) => r.getCommentId() === reply.getCommentId());
    if (index === -1) {
      debug('[onEdit()] index=-1, return.');
      return;
    }

    replies.splice(index, 1, reply);

    return this.props.onEdit(updatedComment);
  };

  renderIndicatorLine = (i) => {
    return (
      <div key={i} className="indicator-line">
        <button onClick={this.onIndicatorLineClick} title={t('EXPAND_REPLIES')}>
          <span className="line" />
          <span className="ellipsis">•</span>
          <span className="ellipsis">•</span>
          <span className="expandRepliesText">
            {this.state.totalCommentCount - 2}&nbsp;{t('REPLIES_HIDE')}
          </span>
          <span className="ellipsis">•</span>
          <span className="line" />
        </button>
      </div>
    );
  };

  drawReplies() {
    const { comment, onRemove, onEditStart, getCommentString } = this.props;
    const replies: Annotation[] = AnnotationUtil.getReplies(comment);
    let didRenderIndicatorLine = false;
    return _.map(replies, (reply, idx) => {
      if (!this.showAllReplies() && idx > 0 && idx < replies.length - 1) {
        if (didRenderIndicatorLine) {
          return null;
        }

        didRenderIndicatorLine = true;
        return this.renderIndicatorLine(idx);
      }

      return (
        <CommentReply
          key={reply.getCommentId() || idx}
          getCommentString={getCommentString}
          reply={reply}
          thread={comment}
          onEdit={this.onEdit}
          onEditStart={onEditStart ?? (() => {})}
          onRemove={(reply) => onRemove(comment, reply)}
        />
      );
    });
  }

  render() {
    const { onCloseRepliesClick } = this.props;
    return (
      <div name="CommentReplies">
        {/* {AnnotationUtil.getReplyCounts(this.props.comment) > 1 && (
          <div style={styles.line}>
            <div style={styles.repliesSeparatorText}>
              REPLIES
              {onCloseRepliesClick ? (
                <span className="toggle" style={styles.toggle} onClick={onCloseRepliesClick}>
                  [-]
                </span>
              ) : null}
            </div>
          </div>
        )} */}
        {this.drawReplies()}
      </div>
    );
  }
}

function getStyle() {
  return {
    line: {
      position: 'relative',
      background: 'var(--primary-style-color)',
      height: 1,
      margin: '10px 0'
    },
    repliesSeparatorText: {
      position: 'absolute',
      background: 'var(--primary-header-bg)',
      color: 'var(--primary-font-color)',
      fontSize: '12px',
      fontWeight: 600,
      letterSpacing: '1px',
      paddingRight: 8,
      top: -8
    },
    toggle: {
      display: 'inline-block',
      marginLeft: 5,
      cursor: 'pointer'
    },
    entry: {
      overflow: 'hidden'
    },
    editButtonsBlock: {
      marginTop: '10px'
    },
    lastEdit: {
      color: 'var(--primary-font-color)',
      fontSize: '11px',
      lineHeight: '13px'
    },
    avatar: {
      marginTop: '10px',
      borderRadius: '50%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      height: '45px',
      width: '45px'
    },
    author: {
      marginTop: '10px',
      color: 'var(--primary-font-color)',
      fontSize: '14px',
      lineHeight: '20px'
    },
    text: {
      marginTop: '5px',
      fontSize: '14px',
      lineHeight: '18px',
      color: 'var(--primary-font-color)',
      wordWrap: 'break-word'
    },
    editBtn: {
      display: 'inline-block',
      float: 'left',
      width: '16px',
      height: '16px',
      backgroundImage: ThemeSetup.getBackgroundURL('edit_asset.svg'),
      marginRight: '10px',
      cursor: 'pointer'
    },
    removeBtn: {
      display: 'inline-block',
      float: 'left',
      width: '16px',
      height: '16px',
      backgroundImage: ThemeSetup.getBackgroundURL('trash_red.svg'),
      cursor: 'pointer'
    }
  };
}
